import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';

import SignInPage from './pages/SignInPage';
import OverviewPage from './pages/OverviewPage';
import PlansPage from './pages/PlansPage';
import CustomersPage from './pages/CustomersPage';
import PaymentsPage from './pages/PaymentsPage';
import ProxiesPage from './pages/ProxiesPage';
import CFDomainsPage from './pages/CFDomainsPage';
import SettingsPage from './pages/SettingsPage';
import StatusPage from './pages/StatusPage';
import CaptchaSolverPage from './pages/CaptchaSolverPage';

import { AppShell } from './components/AppShell';
import { Spinner } from './components/Dialog';
import {
  LayoutDashboard, CreditCard, Users, Receipt, Globe, ShieldCheck,
  Settings as SettingsIcon, Activity, Bot,
} from 'lucide-react';

const NAV = [
  { path: '/',           label: 'Overview',      icon: LayoutDashboard },
  { path: '/customers',  label: 'Customers',     icon: Users },
  { path: '/plans',      label: 'Plans',         icon: CreditCard },
  { path: '/payments',   label: 'Payments',      icon: Receipt },
  { path: '/cf-domains', label: 'CF domains',    icon: ShieldCheck },
  { path: '/proxies',    label: 'Proxies',       icon: Globe },
  { path: '/settings',   label: 'Settings',      icon: SettingsIcon },
  { path: '/captcha-solver', label: 'Captcha solver', icon: Bot },
];

export default function App() {
  const [key, setKey] = useState(localStorage.getItem('datames_admin_key'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg">
        <Spinner size={20} />
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signin" element={
          key ? <Navigate to="/" replace /> : <SignInPage onAuthed={(k) => { localStorage.setItem('datames_admin_key', k); setKey(k); window.location.href = '/'; }} />
        } />
        {/* Public status page — no admin auth required */}
        <Route path="/status" element={<StatusPage />} />
        <Route path="/*" element={
          key ? (
            <Dashboard key={key} onSignOut={() => { localStorage.removeItem('datames_admin_key'); setKey(null); window.location.href = '/signin'; }} />
          ) : (
            <Navigate to="/signin" replace />
          )
        } />
      </Routes>
    </BrowserRouter>
  );
}

function Dashboard({ onSignOut }) {
  const location = useLocation();
  const [adminLabel] = useState(() => {
    const k = localStorage.getItem('datames_admin_key') || '';
    return k.slice(0, 12) + '...';
  });

  return (
    <AppShell
      user={{ email: adminLabel, plan_code: 'operator' }}
      navigation={NAV}
      pathname={location.pathname}
      onSignOut={onSignOut}
      brandLabel="Datames"
      brandSubtitle="Operator"
    >
      <Routes>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/customers/:customerId" element={<CustomersPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/cf-domains" element={<CFDomainsPage />} />
        <Route path="/proxies" element={<ProxiesPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/captcha-solver" element={<CaptchaSolverPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}